export default "__VITE_ASSET__f6be677d__"